export enum POSCategories {
  GET_POS_CATEGORIES_REQUEST = '@poscategories/GET_POS_CATEGORIES_REQUEST',
  GET_POS_CATEGORIES_SUCCESS = '@poscategories/GET_POS_CATEGORIES_SUCCESS',
  GET_POS_CATEGORIES_FAIL = '@poscategories/GET_POS_CATEGORIES_FAIL',
}

export interface IPOSCategoriesPayload {
  siteId: string;
}
